import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable()
export class CoinApiService {
    constructor(private http: HttpClient) {}

    public getBalance(protocol: string, address: string): Observable<any> {
        return this.http.get<any>(`/admin/coinapi/balance/${protocol}/${address}`);
    }

    public getChangeAddresses(): Observable<any> {
        return this.http.get<any>('/admin/coinapi/changeaddreses');
    }

    public getPendingWithdrawalAmounts(): Observable<any> {
        return this.http.get<any>('/admin/coinapi/withdrawals/pendingamount');
    }

    public getCurrencies(): Observable<any> {
        return this.http.get<any>('/admin/coinapi/currencies');
    }

    public getAddressPoolStats(): Observable<any> {
        return this.http.get<any>('/admin/coinapi/addresspoolstats');
    }

    public getTxFees(): Observable<any> {
        return this.http.get<any>('/admin/coinapi/txfees');
    }

    public updateTxFees(currency: any): Observable<any> {
        return this.http.put<any>('/admin/coinapi/txfees', currency);
    }
}
